export default __webpack_public_path__ + "static/media/UserConfig.8bdd7a79.svg";